// <div data-controller="wv--components--update-guide">
//
// </div>
import { Controller } from "stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "" ];
  static classes = [ "" ]
  static values = {
    message: String,
  };

  connect() {
    alert(`${this.messageValue}`);
  }

  disconnect() {

  }
}